const QUERY_PARAMETERS = {
    ADULT_ROOM              : 'adult_room',
    CHECKIN                 : 'skd-checkin',
    CHECKOUT                : 'skd-checkout',
    CHANNEL_ID              : 'skd-channel-id',
    CHILD_ROOM              : 'child_room',
    CURRENCY_CODE           : 'skd-currency-code',
    LANGUAGE                : 'skd-language-code',
    OFFER                   : 'skd-offer-package',
    RATE                    : 'skd-scroll-to-room',
    PROMOTION_CODE          : 'skd-promotion-code',
    PROPERTY_CODE           : 'skd-property-code',
    TOTAL_ROOMS             : 'skd-total-rooms',
    WIDGET_ID               : 'kbe-widget-id',
    WIDGET_SECTION          : 'kbe-widget-section',
    USER                    : 'user',
    PRICE_DISPLAY_MODE      : 'priceDisplayMode',
    PRICE_CALC_MODE         : 'priceCalcMode',
    PAGE                    : 'page',
    PAGE_SIZE               : 'pageSize',
    UPGRADE_TIER_MODAL_OPEN : 'upgrade-tier-modal-open',
    AUTOCOMPLETE_VALUE      : 'custom-classification-from-map',
    AUTOCOMPLETE_TITLE      : 'custom-classification-from-map-title',
    AUTOCOMPLETE_VALUE_TYPE : 'search-type',
    SEARCHBAR_TYPE          : 'searchbar-type',
    SEARCHBAR_CODE          : 'searchbar-code',
    SEARCHBAR_LABEL         : 'searchbar-label',
    SEARCH_ID               : 'skd-search-id',
    SOURCE_CONTEXT          : 'skd-source-context',
    REWARD_PROGRAM          : 'reward-program',
    COUPON                  : 'coupon',
};

const QUERY_PARAMETERS_READABLE = {
    ADULT_ROOM         : 'adult_room',
    CHECKIN            : 'Checkin',
    CHECKOUT           : 'Checkout',
    CHILD_ROOM         : 'child_room',
    CURRENCY_CODE      : 'Currency-code',
    LANGUAGE           : 'Language-code',
    OFFER              : 'Offer-package',
    RATE               : 'Scroll-to-room',
    PROMOTION_CODE     : 'Promotion-code',
    PROPERTY_CODE      : 'Property-code',
    TOTAL_ROOMS        : 'Total-rooms',
    WIDGET_ID          : 'Widget-id',
    WIDGET_SECTION     : 'Widget-section',
    USER               : 'User',
    PRICE_DISPLAY_MODE : 'Price-Display-Mode',
    PRICE_CALC_MODE    : 'Price-Calc-Mode',
    PAGE               : 'Page',
    PAGE_SIZE          : 'Page-Size',
    DESTINATION        : 'Destination-selected',
};

const QUERY_PARAMETERS_TRANSLATIONS = {
    RC                      : 'RC',
    IS_META_REDIRECT        : 'isMetaRedirect',
    CHECKIN                 : 'checkin',
    CHECKOUT                : 'checkout',
    CHANNEL_ID              : 'channelId',
    ADULT_ROOM              : 'adultRoom',
    CHILD_ROOM              : 'childRoom',
    TOTAL_ROOMS             : 'totalRooms',
    LANGUAGE                : 'language',
    CURRENCY_CODE           : 'currencyCode',
    PROMOTION_CODE          : 'promotionCode',
    PROPERTY_CODE           : 'propertyCode',
    OFFER_ROOM              : 'offerRoom',
    OFFER_RATE              : 'offerRate',
    PRICE_TYPE              : 'priceType',
    PRICE                   : 'price',
    CONFIRM_BOOKING_ID      : 'confirmationId',
    PROPERTIES_PAGE_SIZE    : 'propertiesPageSize',
    PROPERTIES_PAGE         : 'propertiesPage',
    OPEN_OCCUPANCY_SELECTOR : 'openOccupancySelector',
    SCROLL_TO_ROOM          : 'scrollToRoom',
    USER_IP                 : 'ipAddress',
    WIDGET_ID               : 'widgetId',
    WIDGET_SECTION          : 'widgetSection',
    SORT_ORDER              : 'sortOrder',
    SHOW_DEMO_PROPERTIES    : 'showDemoProperties',
    UPGRADE_TIER_MODAL_OPEN : 'upgradeTierModalOpen',
    SEARCH_ID               : 'searchId',
};

module.exports = { QUERY_PARAMETERS, QUERY_PARAMETERS_READABLE, QUERY_PARAMETERS_TRANSLATIONS };
